import axios from "@/axios";

const BASE_URL = "/seolbi/alimtalk/tracking";

export const seolbiTrackingApi = {
  // 보증번호별 스텝 진행 목록
  getList(params = {}) {
    return axios.get(BASE_URL, { params });
  },

  // 스텝 타임라인 + 알림톡 시도 원장 (조회 시 조합 상태 자동 동기화)
  getDetail(warrantyNo) {
    return axios.get(`${BASE_URL}/${warrantyNo}`);
  },

  // 조합 보증서 상태 재조회 후 스텝 재계산
  sync(warrantyNo) {
    return axios.post(`${BASE_URL}/${warrantyNo}/sync`);
  },
};

// 스텝 상태별 표기
// 원인이 다르면 색도 달라야 합니다:
//   MISSING  = 조합이 우리 API를 호출하지 않음
//   STALLED  = 큐에는 들어갔는데 mq 컨슈머가 가져가지 않음 (리시버 문제)
//   FAILED   = 컨슈머가 읽었는데 처리/발송에 실패
export const STEP_STATUS_META = {
  DONE: {
    label: "발송 완료",
    color: "#52c41a",
    description: "카카오 발송까지 성공했습니다.",
  },
  IN_FLIGHT: {
    label: "처리 중",
    color: "#1890ff",
    description: "큐에 적재됐거나 컨슈머가 처리 중입니다.",
  },
  STALLED: {
    label: "컨슈머 미수신",
    color: "#eb2f96",
    description:
      "큐에 들어갔는데 mq 컨슈머가 job을 가져가지 않았습니다. 리시버(컨슈머) 상태를 확인하세요.",
  },
  FAILED: {
    label: "실패",
    color: "#f5222d",
    description: "처리 도중 실패했습니다. 실패 단계는 상세에서 확인하세요.",
  },
  MISSING: {
    label: "트리거 없음",
    color: "#fa8c16",
    description:
      "이전 단계는 진행됐는데 발송 시도 기록이 없습니다. 조합 시스템 미호출이 의심됩니다.",
  },
  PENDING: {
    label: "대기",
    color: "#d9d9d9",
    description: "아직 올 차례가 아닙니다.",
  },
};

// 알림톡 시도 원장의 최종 상태
export const ATTEMPT_STATUS_META = {
  QUEUED: { label: "큐 적재 (컨슈머 대기)", color: "blue" },
  CONSUMED: { label: "컨슈머 처리 중", color: "cyan" },
  SENT: { label: "발송 성공", color: "green" },
  FAILED: { label: "실패", color: "red" },
};

// 시도 내부 단계 — 실패 지점을 계층으로 구분합니다.
export const PHASE_META = {
  RECEIVED: {
    label: "트리거 접수",
    description: "[inapi] HTTP 요청 도착 또는 내부 이벤트 수신",
  },
  PREFLIGHT: {
    label: "사전 처리",
    description: "[inapi] 보증요청 단건조회 / 결제 레코드 생성·수정",
  },
  QUEUED: {
    label: "큐 적재",
    description: "[inapi] messageQueue 적재",
  },
  CONSUMED: {
    label: "컨슈머 수신",
    description: "[mq] 컨슈머가 job을 가져감 — 이 단계가 없으면 리시버 문제",
  },
  DISPATCHED: {
    label: "카카오 발송",
    description: "[mq] BizMsg 발송 API 호출 결과",
  },
};

export const TRIGGER_SOURCE_META = {
  HTTP_API: { label: "조합 API 호출", color: "blue" },
  INTERNAL_EVENT: { label: "내부 이벤트", color: "purple" },
};

export const STEP_STATUS_FILTER_OPTIONS = [
  { label: "전체", value: "" },
  { label: "발송 완료", value: "DONE" },
  { label: "처리 중", value: "IN_FLIGHT" },
  { label: "컨슈머 미수신", value: "STALLED" },
  { label: "실패", value: "FAILED" },
  { label: "트리거 없음", value: "MISSING" },
  { label: "대기", value: "PENDING" },
];

// 필터용 스텝 목록 (백엔드 SeolbiStep enum과 값이 일치해야 합니다)
export const STEP_FILTER_OPTIONS = [
  { label: "전체", value: "" },
  { label: "보증서 작성", value: "DRAFT_SAVED" },
  { label: "작성완료", value: "APPLY_COMPLETED" },
  { label: "작성완료 알림톡", value: "APPLY_ALIMTALK" },
  { label: "심사대기", value: "REVIEW_WAITING" },
  { label: "가승인", value: "REVIEW_APPROVED" },
  { label: "심사완료 알림톡", value: "REVIEW_ALIMTALK" },
  { label: "결제완료", value: "PAYMENT_COMPLETED" },
  { label: "결제완료 알림톡", value: "CHARGE_ALIMTALK" },
  { label: "승인완료", value: "FINAL_APPROVED" },
  { label: "승인완료 알림톡", value: "COMPLETED_ALIMTALK" },
];
